// extracted by mini-css-extract-plugin
export default {"MoneyView":"Lx0Usq0N","actionContent":"_2GBAEiSq","img":"rJJI4RJn","text":"vWVlVlvc","imgBox":"y6ltiuLg","speakerImg":"pgvk_Wf7","nextButton":"Z_M5AWl5"};
    if(module.hot) {
      // 1712151480784
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  